import styled from "styled-components";

const Admin = styled.div`
  .helper-text {
    width: 0;
  }
  .helper-text-success {
    color: #4f8a10;
    background-color: #dff2bf;
    padding: 12px;
    width: auto;
  }
  .helper-text-error {
    color: #d8000c;
    background-color: #ffbaba;
    padding: 12px;
    width: auto;
  }
  tr:nth-of-type(odd) {
    
  }
  .liborTable {
    width: 90%;
    margin-top: 20px;
    overflow: auto;
  }
  th {
    padding: 5px;
  }
  .main {
    padding: 20px;
  }
  .userActions button {
    margin-left: auto;
  }

  .dialogInner_PersonalSettings{
    background-color: #FFFFFF;
  }
`;

export default Admin;
